module.exports = __webpack_public_path__ + "img/rullet_raon.c4c54256.png";